/**
 * Access the auth context.
 *
 * Lives apart from the provider so each module exports one kind of thing —
 * see the note in `contexts/authContextValue.ts`.
 */

import { useContext } from 'react'

import { AuthContext, type AuthContextType } from '../contexts/authContextValue'

export function useAuth(): AuthContextType {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider')
    }
    return context
}
